var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.4167 35.7459V56.2542C36.4167 57.7237 37.0875 58.8417 38.4292 59.6084C39.7708 60.3751 41.0805 60.3112 42.3583 59.4167L58.2667 49.2584C59.4805 48.4917 60.0875 47.4056 60.0875 46.0001C60.0875 44.5945 59.4805 43.5084 58.2667 42.7417L42.3583 32.5834C41.0805 31.689 39.7708 31.6251 38.4292 32.3917C37.0875 33.1584 36.4167 34.2765 36.4167 35.7459ZM46 84.3334C40.6972 84.3334 35.7139 83.3265 31.05 81.3127C26.3861 79.3015 22.3292 76.5709 18.8792 73.1209C15.4292 69.6709 12.6985 65.614 10.6873 60.9501C8.67355 56.2862 7.66666 51.3029 7.66666 46.0001C7.66666 40.6973 8.67355 35.714 10.6873 31.0501C12.6985 26.3862 15.4292 22.3292 18.8792 18.8792C22.3292 15.4292 26.3861 12.6974 31.05 10.6836C35.7139 8.67236 40.6972 7.66675 46 7.66675C51.3028 7.66675 56.2861 8.67236 60.95 10.6836C65.6139 12.6974 69.6708 15.4292 73.1208 18.8792C76.5708 22.3292 79.3014 26.3862 81.3127 31.0501C83.3264 35.714 84.3333 40.6973 84.3333 46.0001C84.3333 51.3029 83.3264 56.2862 81.3127 60.9501C79.3014 65.614 76.5708 69.6709 73.1208 73.1209C69.6708 76.5709 65.6139 79.3015 60.95 81.3127C56.2861 83.3265 51.3028 84.3334 46 84.3334Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCircle);
export default __webpack_public_path__ + "static/media/playCircle.141434d503fa4e7306f52273e6830a5a.svg";
export { ForwardRef as ReactComponent };